//////////////////////////////////////////////////////////////////////
//
//  10/12/18
//  src/containers/BarData.js
//
//  This file will contain all the 'canned' Bar Data.
//

//
//  This is the raw Bar data.
//
const BarData = [
 {
   miles : "2.1  mi.",
   name  : "The Living Room",
   music : true,
   food  : false,
   happy : true,
   notes : true,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "Music Sunday Afternoon: 4-6 PM with Kristy Dee.",
   fpop  : "",
   hpop  : "Wine Specials Daily!",
   addr  : "https://www.livingroomwinebar.com/",
 },
 {
   miles : "4.4  mi.",
   name  : "Lustre Bar",
   music : false,
   food  : false,
   happy : true,
   notes : true,
   board : true,
   line1 : "Lustre Bar",
   line2 : "Rooftop Drinks and Dining",
   line3 : "Watch the sun go down!",
   line4 : "Daily Specials",
   mpop  : "Music and Events",
   fpop  : "Food and Drinks",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "https://lustrerooftopbar.com/",
 },
 {
   miles : "5.2  mi.",
   name  : "Side Bar",
   music : false,
   food  : false,
   happy : true,
   notes : true,
   board : true,
   line1 : "-->> Side Bar <<--",
   line2 : "Home of the",
   line3 : "Specialty Cocktails",
   line4 : "Cocktail Lounge",
   mpop  : "",
   fpop  : "",
   hpop  : "Try our White Rabbit",
   addr  : "http://www.sidebarphoenix.com/",
 },
 {
   miles : "6.1  mi.",
   name  : "Classics With a Twist",
   music : false,
   food  : false,
   happy : true,
   notes : false,
   board : true,
   line1 : "A Valley Classic",
   line2 : "A Bar with a Twish!",
   line3 : "Wild Horse Pass",
   line4 : "Happy Hour 5-7",
   mpop  : "",
   fpop  : "",
   hpop  : "Happy Hour Daily 5-7",
   addr  : "",
 },
 {
   miles : "6.7  mi.",
   name  : "Film Bar",
   music : false,
   food  : false,
   happy : true,
   notes : true,
   board : true,
   line1 : "Film Bar",
   line2 : "One-Of-A-Kind",
   line3 : "Best of Phoenix",
   line4 : "Best Indie Cinema",
   mpop  : "",
   fpop  : "",
   hpop  : "Happy Hour Movies and Drinks",
   addr  : "https://thefilmbarphx.com/",
 },
 {
   miles : "7.0  mi.",
   name  : "Bikini Lounge",
   music : false,
   food  : true,
   happy : true,
   notes : false,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "",
   fpop  : "Great Pub Food",
   hpop  : "Happy Hour Daily",
   addr  : "",
 },
 {
   miles : "8.9  mi.",
   name  : "My Wine Cellar",
   music : true,
   food  : true,
   happy : true,
   notes : true,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "Live Music Fri and Sat nights.",
   fpop  : "Wine and Cheese",
   hpop  : "Wine Specials Daily",
   addr  : "https://www.mywinecellarphx.com/",
 },
 {
   miles : "12.4  mi.",
   name  : "Palo Verde Lounge",
   music : true,
   food  : true,
   happy : true,
   notes : false,
   board : false,
   line1 : "",
   line2 : "",
   line3 : "",
   line4 : "",
   mpop  : "Local bands",
   fpop  : "Great Lunch Specials",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "",
 },
 {
   miles : "15.5  mi.",
   name  : "Valley Bar",
   music : false,
   food  : true,
   happy : true,
   notes : false,
   board : true,
   line1 : "Valley Bar",
   line2 : "Visit our Game Room",
   line3 : "Join Our Mailing List",
   line4 : "",
   mpop  : "",
   fpop  : "Kitchen open until 11pm Sun-Thurs, 1am Fri-Sat",
   hpop  : "Weekly Specials",
   addr  : "https://www.valleybarphx.com/",
 },
 {
   miles : "16.0  mi.",
   name  : "The Spurr Lounge",
   music : false,
   food  : false,
   happy : true,
   notes : false,
   board : true,
   line1 : "The Spurr Lounge",
   line2 : "Voted 'Best Dive Bar'",
   line3 : "Music Tonight - 9:00",
   line4 : "Crimson Rose",
   mpop  : "Music Every Sat: 9 - 12 AM",
   fpop  : "Special Today: Mom's Chicken Soup",
   hpop  : "Happy Hour Daily 3-6 PM",
   addr  : "",
 },
];

export default BarData;



// WEBPACK FOOTER //
// ./src/components/BarData.js